<script>
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();
    let next_session_input;
    // console.log(new Intl.DateTimeFormat("default").resolvedOptions().timeZone);
    const timezoneHr = Math.trunc(-(new Date().getTimezoneOffset() / 60));
    const sign = timezoneHr < 0 ? "-" : "+";
    const timezoneMin = new Date().getTimezoneOffset() % 60;
    const timezoneString = `${sign}${
    Math.abs(timezoneHr) < 10 ? "0" + Math.abs(timezoneHr) : Math.abs(timezoneHr)
    }${timezoneMin === 0 ? "00" : Math.abs(timezoneMin)}`;

    // console.log({ timezoneString });
    function handleDateTimeChange() {
        // console.log("next_session_input: ",next_session_input);
        // console.log(`${next_session_input} GMT${timezoneString}`);

        const newDate = new Date(`${next_session_input}${timezoneString}`);

        // console.log({ newDate });

        const timeInMs = Date.parse(newDate);
        console.log({ timeInMs });
        console.log(new Date(timeInMs).toLocaleString());
        dispatch('datetimechange', {
            datetimeMs: timeInMs
        });
    }
</script>

<input type="datetime-local" on:change={handleDateTimeChange} id="next_session_input" name="next_session_input" bind:value={next_session_input}>
